export default function App() {
    return (
      <div>
        <p>about uss2</p>
      </div>
    );
  }
  
  